import React, { useState, useEffect } from 'react';
import AuthService from '../../services/Auth.service';
import './header.css';
import { Fade as Hamburger } from 'hamburger-react';
import { useHistory } from 'react-router-dom';
import { NumberFormat as numberUtils } from '../../utilities/NumberFormat';
import { LogOut } from 'lucide-react';
import { usePage } from '../../context/PageContext';

function Header({ setOpen, isOpen, toggle }) {
   const [showDropdown, setShowDropdown] = useState(false);
   const [user, setUser] = React.useState();
   const { pageTitle } = usePage();
   const history = useHistory();

   useEffect(() => {
      setUser(AuthService.getCurrentUser() || {});
   }, []);

   const username = user?.name || "Guest";
   const userInitial = username.charAt(0).toUpperCase();

   const logout = () => {
      AuthService.logout();
      history.push('/');
      numberUtils.tabTitle('Login');
   };

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (showDropdown && !event.target.closest('.user-profile')) {
            setShowDropdown(false);
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, [showDropdown]);

   return (
      <header className='header'>
         <div className='header-container'>
            <div className='header-left'>
               <div className='hamber-icon'>
                  <ul className='navbar-navbox'>
                     <div className='nav-link' onClick={toggle}>
                        <Hamburger toggled={isOpen} toggle={setOpen} />
                     </div>
                  </ul>
               </div>
               <h1 className='page-title'>{pageTitle}</h1>
            </div>

            <div className='header-right'>
               <div className='user-profile' onClick={() => setShowDropdown(!showDropdown)}>
                  <div className='user-details'>
                     <div className='user-name'>{username}</div>
                     <div className='role-title'>{user?.access}</div>
                  </div>
                  <div className='user-avatar'>
                     <img
                        src="/assets/images/user-img.png"
                        alt="User"
                        style={{ width: "40px", height: "35px", borderRadius: "50%" }}
                     />
                  </div>
                  
                  
                  {showDropdown && (
                     <div className='profile-dropdown'>
                        <div className='dropdown-item' onClick={logout}>
                           <LogOut size={16} className="dropdown-icon" />
                           Logout
                        </div>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </header>
   );
}

export default Header;